function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component, createElement } from "react";

var Block = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Block, _Component);

  function Block() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Block.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        _this$props$el = _this$props.el,
        el = _this$props$el === void 0 ? "div" : _this$props$el,
        className = _this$props.className,
        children = _this$props.children,
        _this$props$layout = _this$props.layout,
        layout = _this$props$layout === void 0 ? "horizontal" : _this$props$layout,
        horizontal = _this$props.horizontal,
        vertical = _this$props.vertical,
        props = _objectWithoutPropertiesLoose(_this$props, ["el", "className", "children", "layout", "horizontal", "vertical"]);

    var classArr = className ? className.split(" ") : [];

    if (layout === "horizontal") {
      classArr.push("block-horizontal-layout");
    } else if (layout === "vertical") {
      classArr.push("block-vertical-layout");
    } else if (layout === "flow") {
      classArr.push("block-flow-layout");
    }

    var justify, align;

    if (layout === "horizontal" || layout === "flow") {
      justify = horizontal;
      align = vertical;
    } else if (layout === "vertical") {
      justify = vertical;
      align = horizontal;
    }

    switch (justify) {
      case "start":
        classArr.push("block-justify-start");
        break;

      case "center":
        classArr.push("block-justify-center");
        break;

      case "end":
        classArr.push("block-justify-end");
        break;

      case "around":
        classArr.push("block-justify-around");
        break;

      case "between":
        classArr.push("block-justify-between");
        break;

      default:
    }

    switch (align) {
      case "start":
        classArr.push("block-align-start");
        break;

      case "center":
        classArr.push("block-align-center");
        break;

      case "end":
        classArr.push("block-align-end");
        break;

      default:
    }

    var newProps = _extends(_extends({}, props), {}, {
      className: classArr.join(" ")
    });

    return createElement(el, newProps, children);
  };

  return Block;
}(Component);

export { Block as default };